import { render, staticRenderFns } from "./CreateBusinessTab.vue?vue&type=template&id=b18370f4&scoped=true&"
import script from "./CreateBusinessTab.vue?vue&type=script&lang=js&"
export * from "./CreateBusinessTab.vue?vue&type=script&lang=js&"
import style0 from "./CreateBusinessTab.vue?vue&type=style&index=0&id=b18370f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18370f4",
  null
  
)

export default component.exports